export default __webpack_public_path__ + "static/media/wallet.5890d52e.svg";